import { useState, useEffect } from "react";
import { Info, X } from "lucide-react";
import { useT } from "../i18n/I18nProvider";

export default function LangBanner() {
  const { lang, t, setLang } = useT();
  const [hidden, setHidden] = useState(false);

  useEffect(() => { setHidden(false); }, [lang]);

  if (lang === "fr" || hidden) return null;

  const title = lang === "en" ? t("langBanner.enTitle") : t("langBanner.plTitle");
  const body = lang === "en" ? t("langBanner.enBody") : t("langBanner.plBody");

  return (
    <div className="bg-amber-50 border-b border-amber-200" data-testid="lang-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-start sm:items-center justify-between gap-4 flex-col sm:flex-row">
        <div className="flex items-start sm:items-center gap-3">
          <Info className="w-4 h-4 text-amber-700 flex-shrink-0 mt-0.5 sm:mt-0" />
          <div className="text-sm">
            <span className="font-semibold text-amber-900">{title}</span>
            <span className="text-amber-800 ml-2">{body}</span>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={() => setLang("fr")}
            className="text-xs font-medium bg-amber-700 hover:bg-amber-800 text-white px-3 py-1.5 rounded-full transition"
            data-testid="lang-banner-switch-fr"
          >
            {t("langBanner.switchToFr")}
          </button>
          <button onClick={() => setHidden(true)} className="p-1 rounded hover:bg-amber-100" data-testid="lang-banner-dismiss" aria-label={t("langBanner.dismiss")}>
            <X className="w-4 h-4 text-amber-700" />
          </button>
        </div>
      </div>
    </div>
  );
}
